module.exports = __webpack_public_path__ + "static/media/Balance-Funds.a040d6d6.svg";